import React from "react";

import CstmProgress from "./CstmProgress";

const ScreenWrapper = (props) => {
  const { showProgress = true } = props;

  let _className = "col-md-10 offset-md-1";

  if (props.fullWidth) {
    _className = "col-md-12";
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-10 offset-md-1">
          {showProgress && (
            <React.Fragment>
              <CstmProgress {...props} />
              <br />
            </React.Fragment>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-md-10 offset-md-1">
          <div className="card">
            <div className="card-block">
              <div className={_className}>{props.children}</div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ScreenWrapper;



// WEBPACK FOOTER //
// ./src/components/ScreenWrapper.js